import script from "./DemoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoView.vue?vue&type=script&setup=true&lang=ts"

import "./DemoView.vue?vue&type=style&index=0&id=e142c2f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e142c2f4"]])

export default __exports__